import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getClassifyList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/getClassifyList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveClassifyInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/saveClassifyInfo`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getClassifyInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`answer/getClassifyInfo`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeClassifyInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`answer/removeClassifyInfo`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDescribeByClassify({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/getDescribeByClassify`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveAnswerDescribe({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/saveAnswerDescribe`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDescribeInfoById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`answer/getDescribeInfoById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateDescribeSituation({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/updateDescribeSituation`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveAnswerFeedback({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/saveAnswerFeedback`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAnswerFeedbackList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/getAnswerFeedbackList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportAnswerFeedbackList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`answer/exportAnswerFeedbackList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportExcelTemplate({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`answer/exportExcelTemplate`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
